import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="text-white bg-very-dark-blue">
      <div className="wrapper px-5 py-12 lg:py-16 md:px-0 lg:mx-20 xl:mx-28 2xl:mx-40 3xl:mx-auto lg:pb-12 lg:px-1 xl:px-3 2xl:px-1  max-w-xl md:max-w-2xl mx-auto lg:max-w-7xl flex flex-col md:flex-row justify-center lg:justify-between items-center md:items-start">
        <div className="w-auto max-w-[180px] my-10 md:my-0">
          <div className="logo mb-6">
            <a href="/" className="cursor-pointer block" aria-label="homepage">
              <img 
                src="/holivana-removebg-preview.png" 
                alt="HOLIVANA Logo" 
                className="h-12 w-auto object-contain"
              />
            </a>
          </div>
          <div className="social flex justify-between items-center gap-4">
            <Link to="#" aria-label="facebook">
              <i className="text-2xl hover:text-orange fab fa-facebook-square transition-colors"></i>
            </Link>
            <Link to="#" aria-label="youtube">
              <i className="text-2xl hover:text-orange fab fa-youtube transition-colors"></i>
            </Link>
            <Link to="#" aria-label="twitter">
              <i className="text-2xl hover:text-orange fab fa-twitter transition-colors"></i>
            </Link>
            <Link to="#" aria-label="instagram">
              <i className="text-2xl hover:text-orange fab fa-instagram transition-colors"></i>
            </Link>
          </div>
        </div>
        <nav className="as flex flex-col sm:flex-row -mt-3 mb-10 md:mb-0 sm:px-10">
          <ul className="px-4">
            <li className="my-3 hover:text-orange w-fit sm:w-full mx-auto sm:mx-0 transition-colors">
              <a href="/collections" className="">
                Collections
              </a>
            </li>
            <li className="my-3 hover:text-orange w-fit sm:w-full mx-auto sm:mx-0 transition-colors">
              <a href="/about-us" className="">
                About us
              </a>
            </li>
            <li className="my-3 hover:text-orange w-fit sm:w-full mx-auto sm:mx-0 transition-colors">
              <a href="/contact" className="">
                Contact
              </a>
            </li>
          </ul>
          <ul className="px-4">
            <li className="my-3 hover:text-orange w-fit sm:w-full mx-auto sm:mx-0 transition-colors">
              <a href="/products" className="">
                Products
              </a>
            </li>
            <li className="my-3 hover:text-orange w-fit sm:w-full mx-auto sm:mx-0 transition-colors">
              <a href="/products/men" className="">
                Immunity
              </a>
            </li>
            <li className="my-3 hover:text-orange w-fit sm:w-full mx-auto sm:mx-0 transition-colors">
              <a href="/products/women" className="">
                Digestion
              </a>
            </li>
          </ul>
        </nav>
        <div className="copyright text-center md:text-left mb-8 md:mb-0">
          © Copyright 2026 HOLIVANA. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
